import React, { useEffect, useRef, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic/build/ckeditor";
import emojiData from "emoji.json";
import Loader from "../loader/loader";

const Editor = ({ value, editorChange }) => {
    const [editorLoaded, setEditorLoaded] = useState(false);
    const [editorInstance, setEditorInstance] = useState(null);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);

    useEffect(() => {
        setEditorLoaded(true);
    }, []);

    const insertEmoji = (emoji) => {
        if (!editorInstance) return;

        editorInstance.model.change((writer) => {
            const pos = editorInstance.model.document.selection.getFirstPosition();
            writer.insertText(emoji, pos);
        });

        setShowEmojiPicker(false);
    };

    if (!editorLoaded) return <Loader />;

    return (
        <div style={{ position: "relative" }}>
            <CKEditor
                editor={ClassicEditor}
                data={value ?? ""}
                onReady={(editor) => {
                    if (!editor || !editor.ui?.view?.toolbar?.element) return;
                    setEditorInstance(editor);

                    const toolbar = editor.ui.view.toolbar.element;
                    const emojiBtn = document.createElement("button");

                    emojiBtn.type = "button";
                    emojiBtn.innerHTML = "😀";
                    emojiBtn.title = "Insert Emoji";
                    emojiBtn.style.background = "transparent";
                    emojiBtn.style.border = "none";
                    emojiBtn.style.cursor = "pointer";
                    emojiBtn.style.fontSize = "20px";
                    emojiBtn.style.marginLeft = "8px";

                    emojiBtn.onclick = () =>
                        setShowEmojiPicker((prev) => !prev);

                    toolbar.appendChild(emojiBtn);
                }}
                onChange={(e, editor) => editorChange(editor.getData())}
                config={{
                    toolbar: {
                        items: [
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "link",
                            "|",
                            "bulletedList",
                            "numberedList",
                            "|",
                            "insertTable",
                            "|",
                            "undo",
                            "redo",
                        ],
                        shouldNotGroupWhenFull: true,
                    },
                    table: {
                        contentToolbar: [
                            "tableColumn",
                            "tableRow",
                            "mergeTableCells",
                        ],
                        tableToolbar: [
                            "tableColumn",
                            "tableRow",
                            "mergeTableCells",
                        ],
                    },
                }}
            />

            {showEmojiPicker && (
                <div
                    style={{
                        position: "absolute",
                        top: 55,
                        right: 10,
                        width: 260,
                        maxHeight: 260,
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ddd",
                        borderRadius: 6,
                        padding: 10,
                        zIndex: 999,
                    }}
                >
                    {emojiData.slice(0, 800).map((e) => (
                        <span
                            key={e.codes}
                            onClick={() => insertEmoji(e.char)}
                            style={{
                                fontSize: 24,
                                margin: 6,
                                cursor: "pointer",
                                display: "inline-block",
                            }}
                        >
                            {e.char}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Editor;
